/**
 * Interactive Map Page - Full district boundary visualization
 */

import { DistrictMap } from '../components/map';

export const InteractiveMapPage = () => {
  return (
    <div className="container mx-auto p-8">
      <div className="mb-6">
        <h1 className="text-3xl font-bold text-gray-900 dark:text-white">District Map</h1>
        <p className="mt-1 text-gray-600 dark:text-gray-400">
          Interactive map of AIU member district boundaries. <strong>Search an address</strong> to find its district, <strong>hover</strong> to see details, <strong>click</strong> to view organization profile. <strong>Zoom</strong> in for district labels and school locations.
        </p>
      </div>

      <div className="bg-white dark:bg-gray-800 rounded-lg shadow overflow-hidden">
        <DistrictMap height="calc(100vh - 220px)" />
      </div>
    </div>
  );
};

export default InteractiveMapPage;
